import React, { useState } from 'react';
import { mdiAccountSwitch } from '@mdi/js';
import { toast } from 'react-toastify';
import { classApi } from '../../api/classes';
import BaseModal from '../BaseModal';
import './ChangeRoleModal.css';

/**
 * ChangeRoleModal — Admin changes a student's role for a specific enrolment
 * Props:
 *   enrolment  - the enrolment object (must have .id and .role)
 *   onClose
 *   onRoleChanged - called after successful role update, triggers enrolments refresh
 */
const ChangeRoleModal = ({ enrolment, onClose, onRoleChanged }) => {
    const [role, setRole] = useState(enrolment.role || 'leader');
    const [isSaving, setIsSaving] = useState(false);
    const student = enrolment.student || {};
    const name = `${student.firstName || ''} ${student.lastName || ''}`.trim() || 'Student';

    const handleSave = async () => {
        setIsSaving(true);
        try {
            const res = await classApi.updateEnrolmentRole(enrolment.id, role);
            if (res.ok) {
                toast.success(`Role updated to ${role}`);
                onRoleChanged();
                onClose();
            } else {
                toast.error(res.data?.message || 'Failed to update role');
            }
        } catch {
            toast.error('Failed to update role');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <BaseModal
            isOpen
            onClose={onClose}
            title="Change Role"
            icon={mdiAccountSwitch}
            maxWidth={360}
            footer={
                <>
                    <button className="base-modal-cancel-btn" onClick={onClose}>Cancel</button>
                    <button className="base-modal-save-btn" onClick={handleSave} disabled={isSaving}>
                        {isSaving ? 'Saving...' : 'Save'}
                    </button>
                </>
            }
        >
            <p className="change-role-student-name">{name}</p>
            <div className="change-role-toggle">
                <button
                    type="button"
                    className={`change-role-btn${role === 'leader' ? ' active-leader' : ''}`}
                    onClick={() => setRole('leader')}>
                    Leader
                </button>
                <button
                    type="button"
                    className={`change-role-btn${role === 'follower' ? ' active-follower' : ''}`}
                    onClick={() => setRole('follower')}>
                    Follower
                </button>
            </div>
        </BaseModal>
    );
};

export default ChangeRoleModal;
